import React, { memo } from "react";
import type { KcContext } from "./kcContext";
import { defaultKcProps as props } from "keycloakify";
import { Login } from "./Login"
import { Register } from "./Register";
import { Info } from "keycloakify/lib/components/Info";
import { Error } from "keycloakify/lib/components/Error";
import { KcApp as KcAppBase } from "keycloakify/lib/components/KcApp";
import "./kcMessagesExtension";
import { Terms } from "keycloakify/lib/components/Terms";

export const KcApp = memo(({ kcContext }: { kcContext: KcContext; }) => {
    switch (kcContext.pageId) {
        case "login.ftl": return <Login kcContext={kcContext} {...props} />;
        case "register.ftl": return <Register kcContext={kcContext} {...props } />;
        case "info.ftl": return <Info kcContext={kcContext} {...props } />;
        case "error.ftl": return <Error kcContext={kcContext} {...props} />;
        case "terms.ftl": return <Terms kcContext={kcContext} {...props} />;
        default: return <KcAppBase kcContext={kcContext} {...props} />;
    }
});
